import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100vw",
        backgroundColor: "#000a4f",
        color: "white",
        // clipPath: "ellipse(85% 90% at 50% 100%)",
        zIndex: 1000,
      }}
      className="py-3 d-md-none "
    >
      <div className="container-fluid" style={{ padding: 0 }}>
        <div className="row text-center pt-2">
          <div className="col">
            <Link to="/dashboard">
              <i className="fa-solid fa-house text-white fa-lg "></i>
              <div className="text-white">Home</div>
            </Link>
          </div>
          <div className="col">
            <Link to="/customer">
              <i className="fa-solid fa-user text-white fa-lg "></i>
              <div className="text-white">Customer</div>
            </Link>
          </div>
          <div className="col">
            <Link to="/recentorders">
              <i className="fa-solid fa-cart-shopping text-white fa-lg "></i>
              <div className="text-white">Recent Orders</div>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
